import { useState } from 'react';
import {
  Box,
  Paper,
} from '@mui/material';
import FiberManualRecordRoundedIcon from '@mui/icons-material/FiberManualRecordRounded';
import BrowseAudioUploader from './BrowseAudioUploader';
import AudioRecorder from './AudioRecorderContainer';
import ButtonList from '../../../../../../components/buttons/ButtonList';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const BROWSE_COMPUTER = 0;
const MY_MEDIA = 1;
const VIZZLE_MEDIA = 2;
const RECORD_SOUND = 3;

const defaultProps = {
  audio: null,
  onAudioApply: () => { },
  onAudioRemoved: () => { },
};

export default function AddAudio(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { audio, onAudioApply, onAudioRemoved } = mergedProps;
  const [state, setState] = useState({
    selectedOption: BROWSE_COMPUTER,
    openFileBrowser: false,
    openAudioRecorder: false,
  });
  const [browseAudioRef, setBrowseAudioRef] = useState();

  const pageTypeSelector = [
    {
      label: 'Browse',
      onClick: () => {
        setState({
          selectedOption: BROWSE_COMPUTER,
          openFileBrowser: true,
        });

        if (browseAudioRef && browseAudioRef.current) {
          browseAudioRef.current.open();
        }
      },
    },
    {
      label: 'Record Sound',
      onClick: () => {
        setState({
          selectedOption: RECORD_SOUND,
          openAudioRecorder: true,
        });
      },
      renderIcon: () => (
        <FiberManualRecordRoundedIcon className='icon-red-with-gradient-boder' />
      ),
    },
  ];

  const setBrowseAudioInputRef = (ref) => {
    setBrowseAudioRef(ref);
    setState({
      ...state,
      openFileBrowser: true,
    });
    if (state.openFileBrowser) {
      ref.current.open();
    }
  };

  const onAudioRecorderClose = () => {
    setState({
      ...state,
      openAudioRecorder: false,
    });
  };

  return (
    <Box height='98%' width='100%' data-test='add-autio-container'>
      <ButtonList
        config={pageTypeSelector}
        align='horizental'
        componentKey='audio-upload-selector'
      />
      <br />
      {(state.selectedOption === BROWSE_COMPUTER
        || state.selectedOption === RECORD_SOUND)
        && (
          <Box height='80%' width='100%'>
            <BrowseAudioUploader
              audio={audio}
              onSelect={onAudioApply}
              onRemove={onAudioRemoved}
              setBrowseAudioRef={setBrowseAudioInputRef}
            />
          </Box>
        )}
      {state.selectedOption === MY_MEDIA && <Paper>MY_MEDIA</Paper>}
      {state.selectedOption === VIZZLE_MEDIA && <Paper>VIZZLE_MEDIA</Paper>}
      {
        window.innerWidth <= 1024 ? <br /> : ''
      }
      <AudioRecorder
        open={state.openAudioRecorder}
        onClose={onAudioRecorderClose}
        onApply={onAudioApply}
      />
    </Box>
  );
}
